var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeech(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 53,
    viewBox: "0 0 51 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "speech bubble",
    d: "M12.7923 42.2862C12.0722 42.2862 11.4685 42.037 10.9814 41.5387C10.4942 41.0404 10.2507 40.423 10.2507 39.6863V34.4866H43.2923V11.0877H48.3756C49.0958 11.0877 49.6994 11.3369 50.1866 11.8352C50.6737 12.3335 50.9173 12.951 50.9173 13.6876V52.6857L40.7506 42.2862H12.7923ZM0.0839844 39.6863V3.28811C0.0839844 2.55147 0.327561 1.934 0.814714 1.4357C1.30187 0.937387 1.90551 0.688232 2.62565 0.688232H35.6673C36.3875 0.688232 36.9911 0.937387 37.4783 1.4357C37.9654 1.934 38.209 2.55147 38.209 3.28811V26.687C38.209 27.4236 37.9654 28.0411 37.4783 28.5394C36.9911 29.0377 36.3875 29.2868 35.6673 29.2868H10.2507L0.0839844 39.6863ZM33.1257 24.0871V5.88798H5.16732V24.0871H33.1257Z",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeech);
export default __webpack_public_path__ + "static/media/speech.1c3e15c488baa3243a3779d133849d55.svg";
export { ForwardRef as ReactComponent };